const devAPI = 'http://localhost:5001';
// const devAPI = 'https://health-checker-api.pyther.com';
const prodAPI = 'https://health-checker-api.pyther.com';

export const getAPIDomain = () => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return devAPI;
  } else {
    return prodAPI;
  }
};
